import { z } from 'zod';
import { ILegalClientAssetRoleId } from './ILegalClientAssetRoleId';

export type ILegalClientAsset = z.infer<typeof ILegalClientAssetSchema>;

export const ILegalClientAssetSchema = z.object({
  idLegalClient: z.number().optional(),
  idAsset: z.number(),
  idLegalClientAssetRole: z.nativeEnum(ILegalClientAssetRoleId),
  share: z.number().min(0).max(100),
  data: z.record(z.any()).optional(),
});

export function createLegalClientAsset(
  idLegalClient: number,
  idAsset: number,
  idLegalClientAssetRole: ILegalClientAssetRoleId,
  share: number,
  data?: Record<string, any>
): ILegalClientAsset {
  return {
    idLegalClient,
    idAsset,
    idLegalClientAssetRole,
    share,
    data,
  };
}
